var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIcWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "yk7kbjq46c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plsp3p9wnf",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "9iivlnzloa",
    d: "M14.997 3.763v-.026C14.997 1.385 13.47 0 10.885 0H4.113C1.527 0 0 1.385 0 3.737v5.121C0 11.21 1.527 12.6 4.113 12.6h6.775C13.473 12.6 15 11.21 15 8.858v-.214h-3.179C10.34 8.642 9.141 7.548 9.143 6.2c.003-1.345 1.2-2.435 2.678-2.437h3.176z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cnga5fj48d",
    d: "M11.962 2.47c.264 0 .483.183.53.422l.008.092v1.772c0 .253-.19.462-.441.506l-.097.008H9.524c-.714.012-1.34-.456-1.496-1.122-.018-.09-.028-.18-.028-.27-.001-.73.58-1.33 1.325-1.4l.142-.008h2.495zm-2.462.7c-.414 0-.75.314-.75.7 0 .387.336.7.75.7s.75-.313.75-.7c0-.386-.336-.7-.75-.7zM5.287.353c.317-.002.576.231.577.52.001.288-.255.523-.571.524H1.055c-.317 0-.573-.236-.572-.524.002-.287.257-.52.572-.52h4.232z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120 -483) translate(0 356) translate(92) translate(16 118) translate(12 9) translate(0 .583)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "noxff5c93b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9iivlnzloa"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#noxff5c93b)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#yk7kbjq46c)",
    d: "M0 0H15V14H0z",
    transform: "translate(.152 -.583)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120 -483) translate(0 356) translate(92) translate(16 118) translate(12 9) translate(0 .583) translate(2.5 2.36)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "iaz5hav2ae",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cnga5fj48d"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#plsp3p9wnf)",
    mask: "url(#iaz5hav2ae)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12.5V5.833H0z"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcWallet);
export default __webpack_public_path__ + "static/media/customer-ic-wallet.9b36e170fd9393993b539ba828ddaefd.svg";
export { ForwardRef as ReactComponent };